import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class="group-manage-email-settings">
  <h3>{{i18n "groups.manage.email.smtp_title"}}</h3>
  <p>{{i18n "groups.manage.email.smtp_instructions"}}</p>

  <label for="enable_smtp">
    <Input
      @type="checkbox"
      @checked={{this.group.smtp_enabled}}
      id="enable_smtp"
      tabindex="1"
      {{on "input" this.smtpEnabledChange}}
    />
    {{i18n "groups.manage.email.enable_smtp"}}
  </label>

  {{#if this.group.smtp_enabled}}
    <GroupSmtpEmailSettings
      @group={{this.group}}
      @smtpSettingsValid={{this.smtpSettingsValid}}
    />
  {{/if}}

  {{#if this.siteSettings.enable_imap}}
    <div class="group-manage-email-imap-wrapper">
      <br />

      <h3>{{i18n "groups.manage.email.imap_title"}}</h3>
      <p>
        {{html-safe (i18n "groups.manage.email.imap_instructions")}}
      </p>

      <div class="alert alert-warning">{{i18n
          "groups.manage.email.imap_alpha_warning"
        }}</div>

      <label for="enable_imap">
        <Input
          @type="checkbox"
          disabled={{not this.enableImapSettings}}
          @checked={{this.group.imap_enabled}}
          id="enable_imap"
          tabindex="8"
          {{on "input" this.imapEnabledChange}}
        />
        {{i18n "groups.manage.email.enable_imap"}}
      </label>

      {{#if this.group.imap_enabled}}
        <GroupImapEmailSettings
          @group={{this.group}}
          @imapSettingsValid={{this.imapSettingsValid}}
        />
      {{/if}}
    </div>
  {{/if}}

  <div class="group-manage-email-additional-settings-wrapper">
    <div class="control-group">
      <h3>{{i18n "groups.manage.email.imap_additional_settings"}}</h3>
      <label
        class="control-group-inline"
        for="allow_unknown_sender_topic_replies"
      >
        <Input
          @type="checkbox"
          name="allow_unknown_sender_topic_replies"
          id="allow_unknown_sender_topic_replies"
          @checked={{this.group.allow_unknown_sender_topic_replies}}
          tabindex="13"
        />
        <span>{{i18n
            "groups.manage.email.settings.allow_unknown_sender_topic_replies"
          }}</span>
      </label>
      <p>{{i18n
          "groups.manage.email.settings.allow_unknown_sender_topic_replies_hint"
        }}</p>
    </div>
  </div>

  <br />
  <GroupManageSaveButton
    @model={{this.group}}
    @disabled={{not this.emailSettingsValid}}
    @beforeSave={{this.beforeSave}}
    @afterSave={{this.afterSave}}
    @tabindex="15"
  />
</div>
*/
{
  "id": "DXpBXUXQ",
  "block": "[[[10,0],[14,0,\"group-manage-email-settings\"],[12],[1,\"\\n  \"],[10,\"h3\"],[12],[1,[28,[35,0],[\"groups.manage.email.smtp_title\"],null]],[13],[1,\"\\n  \"],[10,2],[12],[1,[28,[35,0],[\"groups.manage.email.smtp_instructions\"],null]],[13],[1,\"\\n\\n  \"],[10,\"label\"],[14,\"for\",\"enable_smtp\"],[12],[1,\"\\n    \"],[8,[39,1],[[24,1,\"enable_smtp\"],[24,\"tabindex\",\"1\"],[4,[38,2],[\"input\",[30,0,[\"smtpEnabledChange\"]]],null]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"group\",\"smtp_enabled\"]]]],null],[1,\"\\n    \"],[1,[28,[35,0],[\"groups.manage.email.enable_smtp\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"group\",\"smtp_enabled\"]],[[[1,\"    \"],[8,[39,4],null,[[\"@group\",\"@smtpSettingsValid\"],[[30,0,[\"group\"]],[30,0,[\"smtpSettingsValid\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"siteSettings\",\"enable_imap\"]],[[[1,\"    \"],[10,0],[14,0,\"group-manage-email-imap-wrapper\"],[12],[1,\"\\n      \"],[10,\"br\"],[12],[13],[1,\"\\n\\n      \"],[10,\"h3\"],[12],[1,[28,[35,0],[\"groups.manage.email.imap_title\"],null]],[13],[1,\"\\n      \"],[10,2],[12],[1,\"\\n        \"],[1,[28,[35,5],[[28,[37,0],[\"groups.manage.email.imap_instructions\"],null]],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"alert alert-warning\"],[12],[1,[28,[35,0],[\"groups.manage.email.imap_alpha_warning\"],null]],[13],[1,\"\\n\\n      \"],[10,\"label\"],[14,\"for\",\"enable_imap\"],[12],[1,\"\\n        \"],[8,[39,1],[[16,\"disabled\",[28,[37,6],[[30,0,[\"enableImapSettings\"]]],null]],[24,1,\"enable_imap\"],[24,\"tabindex\",\"8\"],[4,[38,2],[\"input\",[30,0,[\"imapEnabledChange\"]]],null]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"group\",\"imap_enabled\"]]]],null],[1,\"\\n        \"],[1,[28,[35,0],[\"groups.manage.email.enable_imap\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"group\",\"imap_enabled\"]],[[[1,\"        \"],[8,[39,7],null,[[\"@group\",\"@imapSettingsValid\"],[[30,0,[\"group\"]],[30,0,[\"imapSettingsValid\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[10,0],[14,0,\"group-manage-email-additional-settings-wrapper\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n      \"],[10,\"h3\"],[12],[1,[28,[35,0],[\"groups.manage.email.imap_additional_settings\"],null]],[13],[1,\"\\n      \"],[10,\"label\"],[14,0,\"control-group-inline\"],[14,\"for\",\"allow_unknown_sender_topic_replies\"],[12],[1,\"\\n        \"],[8,[39,1],[[24,3,\"allow_unknown_sender_topic_replies\"],[24,1,\"allow_unknown_sender_topic_replies\"],[24,\"tabindex\",\"13\"]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"group\",\"allow_unknown_sender_topic_replies\"]]]],null],[1,\"\\n        \"],[10,1],[12],[1,[28,[35,0],[\"groups.manage.email.settings.allow_unknown_sender_topic_replies\"],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[12],[1,[28,[35,0],[\"groups.manage.email.settings.allow_unknown_sender_topic_replies_hint\"],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,\"br\"],[12],[13],[1,\"\\n  \"],[8,[39,8],null,[[\"@model\",\"@disabled\",\"@beforeSave\",\"@afterSave\",\"@tabindex\"],[[30,0,[\"group\"]],[28,[37,6],[[30,0,[\"emailSettingsValid\"]]],null],[30,0,[\"beforeSave\"]],[30,0,[\"afterSave\"]],\"15\"]],null],[1,\"\\n\"],[13]],[],false,[\"i18n\",\"input\",\"on\",\"if\",\"group-smtp-email-settings\",\"html-safe\",\"not\",\"group-imap-email-settings\",\"group-manage-save-button\"]]",
  "moduleName": "discourse/components/group-manage-email-settings.hbs",
  "isStrictMode": false
});